import React from 'react';

const Char = (props) => (
    <div 
        key={props.id} 
        id={props.id} 
        className={`char-holder ` + props.animType + `-char-holder`}
    >
        <canvas
            className={props.charType + `-` + props.animType + `-cvs`}
            id={props.charType + `-` + props.animType + `-cvs-` + props.id} 
            height="320"
        >
        </canvas>
    </div>
);

export default Char;



// WEBPACK FOOTER //
// ./src/components/sections/shared/Char.js